import styled from 'styled-components';

export const OtakingStyled = styled.div``;
